import { useConfigContext } from "@/app";
import { Image } from "antd-mobile";
import { PropsWithChildren } from "react";
export type ImageLocalProps = PropsWithChildren<{
  className?: string;
  src: string;
}>;
export const ImageLocal = ({
  src
}: ImageLocalProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  return <>
      <Image src={src && getSourcePath(src)} data-sentry-element="Image" data-sentry-source-file="index.tsx"></Image>
    </>;
};